import createOrUpdateHiddenField from './createOrUpdateHiddenField';
import getKeysForExtraInfo from './getKeysForExtraInfo';
import { DEFAULT_AD_PARAMS } from './defaultAdParams';

/**
 * Reads the persisted ws-url-params JSON from sessionStorage.
 * @param {Object} win
 * @returns {Object} key-value map of all persisted URL params
 */
const getUrlParamsFromSession = (win) => {
	try {
		return JSON.parse(win.sessionStorage?.getItem('ws-url-params') || '{}');
	} catch (e) {
		return {};
	}
};

/**
 *
 * @param {Object} win
 * @param {HTMLFormElement} form
 * @param {Object} prefParams
 */
const injectExtraInfo = (
	win,
	form,
	{ cookiesForExtraInfo = '', paramsForExtraInfo = '' } = {}
) => {
	const cookieNames = getKeysForExtraInfo(win, cookiesForExtraInfo);
	const paramNames = getKeysForExtraInfo(win, paramsForExtraInfo);
	const urlParams = getUrlParamsFromSession(win);

	cookieNames.forEach((mappedCookieName, cookieName) => {
		const cookieValue = win.Cookies.get(cookieName);

		// We inject the cookie if it exists
		if (cookieValue) {
			createOrUpdateHiddenField(
				form,
				`_custom=${mappedCookieName.toUpperCase()}=1=${mappedCookieName}`,
				cookieValue
			);
		}
	});

	// First, inject configured params with their mappings
	paramNames.forEach((mappedParamName, paramName) => {
		// Try the new ws-url-params JSON first, fall back to legacy individual keys
		const paramValue =
			urlParams[paramName] ||
			win.sessionStorage?.getItem(`extra-info-param-${mappedParamName}`);

		// We inject the param if it exists
		if (paramValue) {
			createOrUpdateHiddenField(
				form,
				`_custom=${mappedParamName.toUpperCase()}=1=${mappedParamName}`,
				paramValue
			);
		}
	});

	// Then, always inject default ad params (even if custom mapping exists)
	// This ensures extra info always has the standard param names
	DEFAULT_AD_PARAMS.forEach((paramName) => {
		// Try the new ws-url-params JSON first, fall back to legacy individual keys
		const paramValue =
			urlParams[paramName] ||
			win.sessionStorage?.getItem(`extra-info-param-${paramName}`);

		// We inject the param if it exists
		if (paramValue) {
			createOrUpdateHiddenField(
				form,
				`_custom=${paramName.toUpperCase()}=1=${paramName}`,
				paramValue
			);
		}
	});
};
export default injectExtraInfo;
